import React, { Component } from "react";
import { Table } from "antd";
import { Toast } from "antd-mobile-v2";
import "./index.less";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import { clumnData, exportSaveData } from "./const";
import allUrl from "../../api/allUrl";
import tool from "../../api/tool";
class DetialCompt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      uploadFile: false,
      tableData: [],
    };
  }
  componentDidMount() {
    let { detailCompt } = this.props.location.state;
    this.getDetailedData(detailCompt);
  }
  clumnRender = () => {
    return [
      ...clumnData,
      {
        title: "文件",
        dataIndex: "files",
        key: "files",
        render: (text, record, index) => {
          return record.files.length > 0
            ? record.files.map((item, index) => {
                return (
                  <a
                    key={index}
                    onClick={() => {
                      this.uploadFilent(
                        item.fileName,
                        item.businessCode,
                        item.id
                      );
                    }}
                    style={{ textDecoration: "underline" }}
                  >
                    附件{index + 1}&nbsp;
                  </a>
                );
              })
            : null;
        },
      },
    ];
  };
  uploadFilent = (fileName, code, id) => {
    get(allUrl.register.uploadFilen, {
      ossCode: "pet-neiwang",
      businessCode: code,
      ids: id,
    }).then((res) => {
      exportSaveData(res, fileName,this.props);
      if (res.success === true && res.code == 200) {
      }
    });
  };
  // 投诉详情
  getDetailedData = (id) => {
    postRaw(
      allUrl.register.getDetailedData,
      { id: id },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let newData = (res.data && res.data) || {};
          this.setState({
            data: newData,
            tableData:
              newData && newData.tonlineBlfs ? newData.tonlineBlfs : [],
          });
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("获取详情数据失败", 1);
      });
  };
  iFlagrender = (flag) => {
    return flag == "01" ? "是" : "否";
  };
  // 事发地的不同展示
  addressRender = (data) => {
    if (data.applyType == "03") {
      return (
        <div>
          事发地：
          {data.pcComplaintPerson ? data.pcComplaintPerson.orgProvinceName : ""}
          -{data.pcComplaintPerson ? data.pcComplaintPerson.orgCityName : ""}-
          {data.pcComplaintPerson ? data.pcComplaintPerson.orgRegionName : ""}
          &nbsp;
          {data.pcComplaintPerson ? data.pcComplaintPerson.byAddress : ""}
        </div>
      );
    } else {
      return (
        <div>
          事发地：
          {data.pcComplaintDetail
            ? data.pcComplaintDetail.eventProvinceVal
            : ""}
          -
          {data.pcComplaintDetail
            ? data.pcComplaintDetail.eventCityCodeVal
            : ""}
          -{data.pcComplaintDetail ? data.pcComplaintDetail.eventRegionVal : ""}
          &nbsp;
          {data.pcComplaintDetail ? data.pcComplaintDetail.eventAddress : ""}
        </div>
      );
    }
  };
 orgNameData = (DetailedData) => {
    let str = "";
    if (DetailedData.pcComplaintDetail) {
      if (DetailedData.pcComplaintDetail.complaintParentOrgName != "") {
        str = DetailedData.pcComplaintDetail.complaintParentOrgName;
      } else {
        str = DetailedData.pcComplaintDetail.complaintOrgName;
      }
    }
    return str;
  };
  render() {
    const { data, tableData } = this.state;
    return (
      <div className="detail-cont">
        <div className="detail-text">{this.addressRender(data)}</div>
        <div className="detail-text">
          问题类别：
          {data.pcComplaintDetail
            ? data.pcComplaintDetail.complaintTypeVal
            : ""}
        </div>
        <div className="detail-text">
          涉事单位：
          {this.orgNameData(data)}
        </div>
        <div className="detail-text">
          信访日期：{data.applyTime ? data.applyTime : ""}
        </div>
        <div className="lian-text">
          <span>
            联名人数：{" "}
            {data.pcComplaintJoint ? data.pcComplaintJoint.length : 0}
          </span>
          <span
            onClick={() => {
              this.props.history.push({
                pathname: "/asscate",
                state: {
                  lianType: "query",
                },
              });
              tool.set("asscateData", data.pcComplaintJoint || []);
            }}
          >
            查看联名人信息
          </span>
        </div>
        <div className="detail-text">
          是否有复核意见书：
          {data.pcComplaintDetail
            ? this.iFlagrender(data.pcComplaintDetail.hasPosition)
            : ""}
        </div>
        <div className="detail-text">
          是否已行政复议：
          {data.pcComplaintDetail
            ? this.iFlagrender(data.pcComplaintDetail.isReview)
            : ""}
        </div>
        <div className="detail-text">
          法院是否已受理：
          {data.pcComplaintDetail
            ? this.iFlagrender(data.pcComplaintDetail.isAccept)
            : ""}
        </div>
        <div className="detail-text">
          冲裁机构是否已处理：
          {data.pcComplaintDetail
            ? this.iFlagrender(data.pcComplaintDetail.isArbitrate)
            : ""}
        </div>
        <div className="detail-text">
          是否允许公开：
          {data.pcComplaintDetail
            ? this.iFlagrender(data.pcComplaintDetail.isPublic)
            : ""}
        </div>
        <div className="sups-text">
          主要诉求：
          <br />
          <div className="dia-text">
            {data.pcComplaintDetail ? data.pcComplaintDetail.mainAppeal : ""}
          </div>
        </div>
        <div className="sups-text">
          事实和理由：
          <br />
          <div className="dia-text">
            {data.pcComplaintDetail
              ? `${data.pcComplaintDetail.complaintReason}`
              : ""}
          </div>
        </div>
        <div className="detail-text">本次办理方式</div>
        <div className="table-cont">
          <div className="table-cont-wrap">
            <Table
              columns={this.clumnRender()}
              dataSource={tableData}
              loading={this.state.uploadFile}
              size="small"
            />
          </div>
        </div>
      </div>
    );
  }
}
export default DetialCompt;
